import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const hostSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => ({
        url: API_PREFIX + "/host/",
        method: "GET",
      }),
      providesTags: ["Host"],
    }),
    getHost: builder.query({
      query: (host_uuid) => ({
        url: API_PREFIX + "/host/profile/" + host_uuid,
        method: "GET",
      }),
    }),
    getHostProperties: builder.query({
      query: (host_uuid) => ({
        url: API_PREFIX + `/property/host/${host_uuid}`,
        method: "GET",
      }),
      providesTags: ["property"],
    }),
    getHostExperiences: builder.query({
      query: (host_uuid) => ({
        url: API_PREFIX + `/experience/host/${host_uuid}`,
        method: "GET",
      }),
      providesTags: ["experience"],
    }),
    getHostHolidayPackages: builder.query({
      query: (host_uuid) => ({
        url: API_PREFIX + `/holiday_package/host/${host_uuid}`,
        method: "GET",
      }),
      providesTags: ["holidayPackage"],
    }),
    uploadAvatar: builder.mutation({
      query: (file) => ({
        url: API_PREFIX + "/host/upload/cover",
        method: "POST",
        body: file,
      }),
    }),
    updateHost: builder.mutation({
      query: (host) => ({
        url: API_PREFIX + "/host/update",
        method: "PUT",
        body: host,
      }),
      invalidatesTags: ["Host"],
    }),
    createStripeAccount: builder.mutation({
      query: () => ({
        url: API_PREFIX + "/host/stripe/create-account",
        method: "POST",
      }),
    }),
    stripeLogin: builder.query({
      query: () => ({
        url: API_PREFIX + "/host/stripe/login",
        method: "GET",
      }),
    }),
    getAllMyProperties: builder.query({
      query: () => ({
        url: API_PREFIX + "/host/properties",
        method: "GET",
      }),
    }),
    getAllMyExperiences: builder.query({
      query: () => ({
        url: API_PREFIX + "/host/experiences",
        method: "GET",
      }),
    }),
    getAllMyHolidayPackages: builder.query({
      query: () => ({
        url: API_PREFIX + "/host/holiday_packages",
        method: "GET",
      }),
    }),
    getHostBookings: builder.query({
      query: (filter) => ({
        url: API_PREFIX + `/host/bookings/${filter}`,
        method: "GET",
      }),
    }),
    updateHostSelf: builder.mutation({
      query: (host) => ({
        url: API_PREFIX + "/host/updateSelf",
        method: "PUT",
        body: host,
      }),
      invalidatesTags: ["Host"],
    }),
    changeHostPassword: builder.mutation({
      query: ({ oldPassword, newPassword }) => ({
        url: API_PREFIX + "/host/changePassword",
        method: "POST",
        body: { oldPassword, newPassword },
      }),
      invalidatesTags: ["Host"],
    }),
    getHostStats: builder.query({
      query: () => ({
        url: API_PREFIX + `/host/stats/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetMeQuery,
  useLazyGetMeQuery,
  useUploadAvatarMutation,
  useUpdateHostMutation,
  useCreateStripeAccountMutation,
  useStripeLoginQuery,
  useGetAllMyPropertiesQuery,
  useGetAllMyExperiencesQuery,
  useGetAllMyHolidayPackagesQuery,
  useLazyGetAllMyExperiencesQuery,
  useLazyGetAllMyPropertiesQuery,
  useLazyGetAllMyHolidayPackagesQuery,
  useLazyGetHostQuery,
  useGetHostQuery,
  useGetHostPropertiesQuery,
  useGetHostExperiencesQuery,
  useGetHostHolidayPackagesQuery,
  useLazyGetHostBookingsQuery,
  useGetHostBookingsQuery,
  useChangeHostPasswordMutation,
  useUpdateHostSelfMutation,
  useGetHostStatsQuery,
} = hostSlice;
